import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, SITE_NAME, OG_IMAGE } from "@/lib/seo";

// Per-page SEO. Accepts explicit props (used by detail pages) with sensible defaults.
export default function Seo({ title, description, path = "/", image = OG_IMAGE, type = "website", noindex = false, lang = "en" }) {
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const fullTitle = title || SITE_NAME;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex ? <meta name="robots" content="noindex, follow" /> : <meta name="robots" content="index, follow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === "ar" ? "ar_SA" : "en_US"} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
